import { BaseUseCase } from "../UseCaseBase";
class NewOnEdelUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getNewOnEdelData();
    }
}
export default NewOnEdelUseCase;
